export const COMMAND_PALETTE_OPEN_EVENT = 'sellaris:open-command-palette';

/** Opens the global command palette from anywhere (e.g. the dashboard search bar). */
export const openCommandPalette = () =>
  window.dispatchEvent(new Event(COMMAND_PALETTE_OPEN_EVENT));
